// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jeNDSInputColumnDiv--WhNXx {
  display: flex;
  flex-direction: column-reverse;
  flex-grow: 1;
}

.jeInputText--Ab2st {
  border: none;
  outline: 0;
  letter-spacing: 0;
  vertical-align: middle;
  font-family: var(--font-family-body);
  padding: 0;
  width: 100%;
  font-size: var(--font-size-default);
  color: var(--color-grey);
}

.jeInputTextWrapper--rsKrw {
  box-sizing: border-box;
  border: 1px solid var(--color-lightGrey);
  background: var(--color-white);
  position: relative;
  width: 100%;
  padding: 7px 0.8em;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.jeInputTextWrapper--rsKrw:has(textarea) {
  padding: 7px 0 0 0.8em;
  align-items: stretch;
}

.jeInputTextWrapper--rsKrw textarea {
  border: none;
  outline: none;
  font-family: var(--font-family-body);
  font-size: var(--font-size-default);
  padding: 4px 0;
}

.jeInputTextWrapper--rsKrw:focus-within {
  border: 1px solid var(--theme-primary);
}

.jeDescription--mFGz8 {
  font-size: var(--font-size-xs);
  background: transparent;
  pointer-events: none;
  font-family: var(--font-family-body);
  font-weight: 400;
  color: var(--color-mediumGrey);
  line-height: 1.15;
  white-space: normal;
  overflow: visible;
  word-break: break-word;
  grid-column: 1 / -1;
  margin-top: 3px;
}

.jeTextareaLabel--JRyDO {
  margin: 0 0 2px;
}

.jeFormControl--sKNhf {
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: baseline;
  flex: auto;
}

.jeSelect--G8rZw {
  margin-right: 0.5em;
}

.jeCheckbox--JZwbO {
  display: inline-block;
  width: auto;
  margin-right: 0.5em;
}

.jeControlGroup--fkkGe {
}

.jeControlGroup--fkkGe .jeCheckbox--JZwbO {
  margin-right: 0;
}

.jeSwitcher--SOUlb {
  display: inline-block;
  font-style: italic;
  margin-top: 1em;
  width: 100%;
}

.jeLabel--FW236 {
  flex: auto;
  min-width: fit-content;
  max-width: fit-content;
  margin-right: 0.5em;
}

.jeChildEditorHolder--zjJgD {
  margin-top: 0.5em;
}

.jeButtonHolder--Q0LEv {
}

.jeHeader--DA6YZ {
  display: inline-block;
  margin-bottom: 0.5em;
}

.jeIndentedPanel--sf3eW {
  margin-bottom: 0.5em;
}

.jeIndentedPanel--sf3eW > div {
  margin-bottom: 0.5em;
}

.jeGridRow--OaXYo {
  margin-bottom: 0.5em;
}

.required--fgKMw:after {
  content: " *";
  color: var(--color-errorDark);
  font: inherit;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/institution_settings/NarmiTheme.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AACA;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;AACnB","sourcesContent":[".jeNDSInputColumnDiv {\n  display: flex;\n  flex-direction: column-reverse;\n  flex-grow: 1;\n}\n\n.jeInputText {\n  border: none;\n  outline: 0;\n  letter-spacing: 0;\n  vertical-align: middle;\n  font-family: var(--font-family-body);\n  padding: 0;\n  width: 100%;\n  font-size: var(--font-size-default);\n  color: var(--color-grey);\n}\n\n.jeInputTextWrapper {\n  box-sizing: border-box;\n  border: 1px solid var(--color-lightGrey);\n  background: var(--color-white);\n  position: relative;\n  width: 100%;\n  padding: 7px 0.8em;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.jeInputTextWrapper:has(textarea) {\n  padding: 7px 0 0 0.8em;\n  align-items: stretch;\n}\n\n.jeInputTextWrapper textarea {\n  border: none;\n  outline: none;\n  font-family: var(--font-family-body);\n  font-size: var(--font-size-default);\n  padding: 4px 0;\n}\n\n.jeInputTextWrapper:focus-within {\n  border: 1px solid var(--theme-primary);\n}\n\n.jeDescription {\n  font-size: var(--font-size-xs);\n  background: transparent;\n  pointer-events: none;\n  font-family: var(--font-family-body);\n  font-weight: 400;\n  color: var(--color-mediumGrey);\n  line-height: 1.15;\n  white-space: normal;\n  overflow: visible;\n  word-break: break-word;\n  grid-column: 1 / -1;\n  margin-top: 3px;\n}\n\n.jeTextareaLabel {\n  margin: 0 0 2px;\n}\n\n.jeFormControl {\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  align-items: baseline;\n  flex: auto;\n}\n\n.jeSelect {\n  margin-right: 0.5em;\n}\n\n.jeCheckbox {\n  display: inline-block;\n  width: auto;\n  margin-right: 0.5em;\n}\n\n.jeControlGroup {\n}\n\n.jeControlGroup .jeCheckbox {\n  margin-right: 0;\n}\n\n.jeSwitcher {\n  display: inline-block;\n  font-style: italic;\n  margin-top: 1em;\n  width: 100%;\n}\n\n.jeLabel {\n  flex: auto;\n  min-width: fit-content;\n  max-width: fit-content;\n  margin-right: 0.5em;\n}\n\n.jeChildEditorHolder {\n  margin-top: 0.5em;\n}\n\n.jeButtonHolder {\n}\n\n.jeHeader {\n  display: inline-block;\n  margin-bottom: 0.5em;\n}\n\n.jeIndentedPanel {\n  margin-bottom: 0.5em;\n}\n\n.jeIndentedPanel > div {\n  margin-bottom: 0.5em;\n}\n\n.jeGridRow {\n  margin-bottom: 0.5em;\n}\n\n.required:after {\n  content: \" *\";\n  color: var(--color-errorDark);\n  font: inherit;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jeNDSInputColumnDiv": `jeNDSInputColumnDiv--WhNXx`,
	"jeInputText": `jeInputText--Ab2st`,
	"jeInputTextWrapper": `jeInputTextWrapper--rsKrw`,
	"jeDescription": `jeDescription--mFGz8`,
	"jeTextareaLabel": `jeTextareaLabel--JRyDO`,
	"jeFormControl": `jeFormControl--sKNhf`,
	"jeSelect": `jeSelect--G8rZw`,
	"jeCheckbox": `jeCheckbox--JZwbO`,
	"jeControlGroup": `jeControlGroup--fkkGe`,
	"jeSwitcher": `jeSwitcher--SOUlb`,
	"jeLabel": `jeLabel--FW236`,
	"jeChildEditorHolder": `jeChildEditorHolder--zjJgD`,
	"jeButtonHolder": `jeButtonHolder--Q0LEv`,
	"jeHeader": `jeHeader--DA6YZ`,
	"jeIndentedPanel": `jeIndentedPanel--sf3eW`,
	"jeGridRow": `jeGridRow--OaXYo`,
	"required": `required--fgKMw`
};
export default ___CSS_LOADER_EXPORT___;
